import { useCallback, useSyncExternalStore } from "react";
import { useRowSelectionContext } from "../context/RowSelectionContext";

export const useRowSelectionCell = (id: string) => {
  const { store } = useRowSelectionContext();

  const getSnapshot = useCallback(() => store.isSelected(id), [store, id]);

  const isSelected = useSyncExternalStore(store.subscribe, getSnapshot);

  const toggle = useCallback(() => {
    store.toggle(id);
  }, [store, id]);

  return {
    isSelected,
    toggle,
  };
};
